<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 酒店管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!--<el-button
                        type="primary"
                        icon="el-icon-delete"
                        class="handle-del mr10"
                        @click="delAllSelection"
                >批量删除
                </el-button>-->
                <!--<el-select class="handle-select mr10 wd200" clearable placeholder="住宿区域" v-model="search.menu">
                    <el-option :key="item.Id"
                               :label="item.Cname"
                               :value="item.Id"
                               v-for="item in hotelOpt.hotelCity"></el-option>
                </el-select>-->
                <el-input class="handle-input mr10" clearable placeholder="区域关键字" v-model="query.keyword"></el-input>
                <el-button @click="handleSearch" icon="el-icon-search" type="primary">搜索</el-button>
                <el-button @click="getHotelData" icon="el-icon-refresh" type="warning">刷新</el-button>
            </div>
            <el-table
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    border
                    class="table"
                    header-cell-class-name="table-header"
                    ref="multipleTable"
            >
                <el-table-column align="center" label="ID" prop="Id" sortable width="65"></el-table-column>
                <el-table-column label="酒店名称" prop="Hname" sortable width="280"></el-table-column>
                <!-- <el-table-column align="center" label="酒店类型" sortable>
                     <template slot-scope="scope">
                         <el-tag
                                 :type="scope.row.Htype===1?'danger':(scope.row.Htype===2?'success':'info')"
                         >
                             {{scope.row.Htype===1?'标准酒店':(scope.row.Htype===2?'，乡村民宿':(scope.row.Htype===3?'，家庭旅馆':'公寓酒店'))}}
                         </el-tag>
                     </template>

                 </el-table-column>-->
                <el-table-column align="center" label="酒店星级">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Hstar===2?'danger':(scope.row.Hstar===3?'success':'info')"
                        >
                            {{scope.row.Hstar===2?'二星(钻)级及以下':(scope.row.Hstar===3?'三星(钻)级':(scope.row.Hstar===4?'四星(钻)级':'五星(钻)级'))}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="装修/开业时间" prop="Hdecoration"></el-table-column>
                <el-table-column align="center" label="网络评分" prop="Hscore"></el-table-column>
                <el-table-column align="center" label="房间数量" prop="Hsum" sortable></el-table-column>
                <el-table-column align="center" label="团队价格" prop="Hcoop_price" sortable></el-table-column>
                <el-table-column align="center" label="散客价格" prop="Hcoop_sprice" ></el-table-column>
                <el-table-column align="center" label="价格有效期" prop="Hprice_exp" ></el-table-column>
                <el-table-column align="center" label="合作等级" >
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Hserve===0?'danger':(scope.row.Hserve===1?'info':'success')"
                        >{{scope.row.Hstate===0?'免费展示':(scope.row.Hstate===1?'AA级会员':'AAA级会员')}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="酒店状态" sortable>
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Hstate===0?'danger':(scope.row.Hstate===1?'info':'success')"
                        >{{scope.row.Hstate===0?'下线':(scope.row.Hstate===1?'正常':'推荐')}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="250">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleEdit(scope.$index, scope.row)"
                                icon="el-icon-edit"
                                type="text"
                        >编辑
                        </el-button>
                        <el-button
                                @click="updatePolicy(scope.$index, scope.row)"
                                icon="el-icon-s-ticket"
                                type="text"
                        >结算价格
                        </el-button>
                        <el-button
                                @click="showContacts(scope.$index, scope.row)"
                                icon="el-icon-s-cooperation
"
                                type="text"
                        >联系人信息
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="searchPage" v-show="show.search">
                共计 【 {{pageTotal}} 】条符合条件的结果
            </div>

            <div class="pagination" v-show="show.page">
                <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        background
                        layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 编辑酒店信息 -->
        <el-dialog :visible.sync="editVisible" title="编辑酒店信息" width="50%">
            <el-form :model="form" label-width="100px" ref="form">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="酒店名称">
                            <el-input clearable v-model="form.Hname"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="装修/开业">
                            <el-date-picker
                                    placeholder="选择日期"
                                    style="width: 100%;"
                                    type="date"
                                    v-model="form.Hdecoration"
                                    value-format="yyyy-MM-dd"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="房间数量">
                            <el-input class="wd200" v-model="form.Hsum"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="酒店等级">
                            <el-select filterable placeholder="请选择" v-model="form.Hstar">
                                <el-option
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        v-for="item in hotelOpt.star">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="酒店类型">
                            <el-select placeholder="请选择" v-model="form.Htype">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in hotelOpt.type"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="网络评分">
                            <el-input clearable v-model="form.Hscore"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="所属区域">
                            <el-cascader v-model="form.Harea"
                                         :options="hotelOpt.areaOpt"
                                         :props="{ checkStrictly: true }"
                                         clearable></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="14">
                        <el-form-item label="酒店地址">
                            <el-input v-model="form.Hadd"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="5">
                        <el-form-item label="团队价格">
                            <el-input class="wd100" v-model="form.Hcoop_price"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="散客价格">
                            <el-input class="wd100" v-model="form.Hcoop_sprice"></el-input>
                        </el-form-item>
                    </el-col>
<!--                    <el-col :span="8">
                        <el-form-item>
                            <el-switch v-model="form.Hprice" active-text="团散同价" active-value="1" inactive-text="团散不同价" inactive-value="0"></el-switch>
                        </el-form-item>
                    </el-col>-->
                    <el-col :span="7">
                        <el-form-item label="价格时效">
                            <el-date-picker
                                    placeholder="选择日期"
                                    style="width: 100%;"
                                    type="date"
                                    v-model="form.Hprice_exp"
                                    value-format="yyyy-MM-dd"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="补充说明">
                            <el-input class="wd600" clearable v-model="form.Hprice_memo" placeholder="1、散客房 是否含早？  2、周末是否加钱？ "></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="酒店状态">
                            <el-select placeholder="请选择" v-model="form.Hstate">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in hotelOpt.state"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="合作等级">
                            <el-select placeholder="请选择" v-model="form.Hserve">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in hotelOpt.cooplevel"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>


                <el-row :gutter="20">
                    <el-form-item label="酒店描述">
                        <el-input
                                maxlength="255"
                                placeholder="请输入内容"
                                rows="6"
                                show-word-limit
                                type="textarea"
                                v-model="form.Hdescription"
                        >
                        </el-input>
                    </el-form-item>
                </el-row>

                <el-row :gutter="20">
                    <el-form-item label="内部政策">
                        <el-input
                                maxlength="255"
                                placeholder="请输入内容"
                                rows="6"
                                show-word-limit
                                type="textarea"
                                v-model="form.Hinnermemo"
                        >
                        </el-input>
                    </el-form-item>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="携程ID">
                            <el-input class="wd200" v-model="form.Nctrip"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="美团ID">
                            <el-input class="wd200" v-model="form.Nmeituan"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="去哪儿ID">
                            <el-input class="wd200" v-model="form.Nqunar"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button @click="saveEdit" type="primary">确 定</el-button>
            </span>
        </el-dialog>


        <!-- 弹出框@编辑酒店销售结算政策 -->
        <el-dialog :visible.sync="policyVisible" title="管理酒店价格政策图片" width="80%">
            <el-upload
                    :before-remove="beforeRemove"
                    :before-upload="beforeAvatarUpload"
                    :file-list="fileList"
                    :http-request="upload"
                    :limit="10"
                    :on-exceed="handleExceed"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    action=""
                    list-type="picture">
                <i class="el-icon-plus"></i>
            </el-upload>


        </el-dialog>
        <!--<el-dialog :visible.sync="policy_Visible" title="政策文件详情展示" width="80%">
            <img :src="policy_ImageUrl" alt="" width="100%">
        </el-dialog>-->

        <el-dialog :visible.sync="picture_Visible" title="图片详情展示" width="80%">
            <img :src="picture_ImageUrl" alt="" width="100%">
        </el-dialog>

        <!-- 弹出框@编辑景点联系人信息 -->
        <el-dialog :visible.sync="contactsVisible" title="管理酒店联系人信息" width="80%">
            <el-form :model="form" label-width="70px" ref="form">

                <el-row :gutter="24" v-for="(person, index) in contactsList" :key="index">
                    <el-col :span="5">
                        <el-form-item label="职位类型">
                            <el-select placeholder="请选择" v-model="person.Crole">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in contactType"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="姓名">
                            <el-input clearable v-model="person.Cname"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="电话号码">
                            <el-input clearable v-model="person.Cphone"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="备注说明">
                            <el-input clearable v-model="person.Cmemo"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" @click="updateContact(person)">保存</el-button>
                    </el-col>
                </el-row>
                <el-button @click="addContacts">+新增联系人</el-button>
            </el-form>

        </el-dialog>

        <!-- 弹出框@对景点拥有的图片/文件展示排序 -->
        <el-dialog :visible.sync="orderVisible" title="景点所属图片/文件信息" width="80%">
            <template>
                <el-table
                        :data="orderData"
                        style="width: 100%">

                    <el-table-column
                            label="文件ID"
                            prop="id"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            label="查看图片"
                            width="80">
                        <template slot-scope="scope">
                            <el-link type="primary" @click="openImg(scope.row.url)">查看图片</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="文件名称">
                        <template slot-scope="scope">
                            <el-input class="wd400 mr10" v-model="scope.row.name" placeholder="图片描述"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="更新时间"
                            prop="time"
                            width="180">
                    </el-table-column>

                    <el-table-column
                            label="排序编号"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-input class="wd100 mr10" v-model="scope.row.order" placeholder="排序编号"></el-input>

                            <el-button @click="saveImgOrder(scope.row.order,scope.row.name,scope.row.id)"
                                       type="primary">确 定
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>

        </el-dialog>


    </div>
</template>

<script>
    export default {
        name: 'basetable',
        data() {
            return {
                hotelOpt: {
                    areaOpt: [],
                    opt: [],
                    type: [{
                        value: 0,
                        label: '家庭旅馆'
                    }, {
                        value: 1,
                        label: '经济旅店'
                    }, {
                        value: 2,
                        label: '床位出租'
                    }, {
                        value: 3,
                        label: '自助公寓'
                    }, {
                        value: 4,
                        label: '酒店宾馆'
                    }],
                    star: [{
                        value: 2,
                        label: '二星(钻)级及以下'
                    }, {
                        value: 3,
                        label: '三星(钻)级'
                    }, {
                        value: 4,
                        label: '四星(钻)级'
                    }, {
                        value: 5,
                        label: '五星(钻)级'
                    }],
                    state: [{
                        value: 0,
                        label: '屏蔽中'
                    }, {
                        value: 1,
                        label: '正显示'
                    }, {
                        value: 2,
                        label: '正推荐'
                    }],
                    cooplevel: [{
                        value: 0,
                        label: '免费展示'
                    }, {
                        value: 1,
                        label: 'AA级会员'
                    }, {
                        value: 2,
                        label: 'AAA级会员'
                    }],
                    free: {}
                },
                query: {
                    keyword: '',
                    menu: '',
                    mid: sessionStorage.getItem('ml_cityId'),
                    address: '',
                    name: '',
                    pageIndex: 1,
                    pageSize: 10
                },
                show: {
                    page: true,
                    search: false
                },
                pageTotal: 0,
                tableData: [],
                resultData: 0,
                multipleSelection: [],
                delList: [],
                editVisible: false,
                addVisible: false,
                form: {},
                idx: -1,
                id: -1,
                contactsList: [],
                fileList: [],

                contactType: [{
                    value: 0,
                    label: '前台-客服'
                }, {
                    value: 1,
                    label: '销售-营销'
                }, {
                    value: 2,
                    label: '三方-渠道'
                }],
                picture_ImageUrl: '',
                picture_Visible: false,

                contactsVisible: false,
                policyVisible: false,
                orderVisible: false,
                orderData: []

            };
        },
        created() {
            this.getHotelData();
        },
        methods: {

            //新增联系人信息
            async addContacts() {
                const { data: res } = await this.$http.post('admin/contacts/addContacts', {
                    Cpid: this.form.Id,
                    Cstate: 1,
                    Crole: 1,
                    Ctype: 2
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，未能添加联系人，请联系管理员!');
                } else {
                    this.$message.success('【联系人数据】更新成功!');
                    const { data: res } = await this.$http.post('/admin/contacts/showContacts', {
                        pid: this.form.Id,
                        type: 2
                    });
                    this.contactsList = res.list;
                }
            },

            // 展示酒店联系人信息
            async showContacts(index, row) {
                this.idx = index;
                this.form = row;
                this.contactsVisible = true;
                const { data: res } = await this.$http.post('/admin/contacts/showContacts', {
                    pid: this.form.Id,
                    type: 2
                });
                this.contactsList = res.list;
            },

            // 展示酒店结算政策文件
            async updatePolicy(index, row) {
                this.idx = index;
                this.form = row;
                this.policyVisible = true;
                const { data: res } = await this.$http.post('/admin/scenics/getImages', {
                    pid: this.form.Id,
                    type: '4'
                });
                this.image_type = '4';
                this.fileList = res;
            },

            //修改保存 联系人信息
            async updateContact(person) {
                const { data: res } = await this.$http.post('admin/contacts/updateContacts', {
                    Id: person.Id,
                    Cname: person.Cname,
                    Cphone: person.Cphone,
                    Cmemo: person.Cmemo,
                    Crole: person.Crole
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，修改联系人失败，请联系管理员!');
                } else {
                    this.$message.success('【联系人数据】更新成功!');
                }
            },

            //酒店等级列表 数据
            async getHotelData() {
                const { data: res } = await this.$http.post('admin/hotels/initHotelData', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取数据失败，请联系管理员!');
                }
                this.hotelOpt.areaOpt = res.cityOpt;
                this.hotelOpt.opt = res.hotelopt;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal;

                this.query.keyword = '';
                //   this.show.page = true;
                // this.show.search = false;
                this.$message.success('【酒店数据】加载成功!');
            },

            // 触发搜索按钮
            async handleSearch() {
                this.query.pageSize=500;
                const { data: res } = await this.$http.post('admin/hotels/searchHotel', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取住宿数据失败，请联系管理员!');
                }
                this.hotelOpt.areaOpt = res.cityOpt;
                this.hotelOpt.opt = res.hotelopt;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal;
                this.$message.success('搜索成功，共有【 ' + res.pageTotal + ' 】符合条件的结果');
            },
            // 删除操作
            handleDelete(index, row) {
                // 二次确认删除
                this.$confirm('确定要删除吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        this.$message.success('删除成功');
                        this.tableData.splice(index, 1);
                    })
                    .catch(() => {
                    });
            },
            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAllSelection() {
                const length = this.multipleSelection.length;
                let str = '';
                this.delList = this.delList.concat(this.multipleSelection);
                for (let i = 0; i < length; i++) {
                    str += this.multipleSelection[i].name + ' ';
                }
                this.$message.error(`删除了${str}`);
                this.multipleSelection = [];
            },
            // 编辑酒店 操作
            handleEdit(index, row) {
                this.idx = index;
                this.form = row;
                this.editVisible = true;
            },

            // 保存酒店 操作
            async saveEdit() {
                this.editVisible = false;
                this.$set(this.tableData, this.idx, this.form);
                const { data: res } = await this.$http.post('/admin/hotels/addHotel', {
                    form: this.form
                });
                if (res.code !== 200) {
                    this.addVisible = false;
                    return this.$message.error('系统错误，修改酒店数据失败，请联系管理员!');
                }
                this.$message.success(res.message);
                this.addVisible = false;
            },
            // 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                this.getHotelData();
            },
            //标签筛选
            filterTag(value, row) {
                return row.Sstate == value;
            },
            //上传文件
            async upload(param) {
                const formData = new FormData();
                formData.append('file', param.file);
                formData.append('pid', this.form.Id);
                formData.append('city', this.form.DestName);
                formData.append('image_type', this.image_type);
                const { data: res } = await this.$http.post('/admin/hotels/upload_img', formData);
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取酒店数据失败，请联系管理员!');
                }
                this.$message.success('【酒店结算图片/文件】上传成功!');
            },

            //上传前的检查判断
            beforeAvatarUpload(file) {
                const isJPG =
                    file.type === 'image/gif' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/jpeg' ||
                    file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error('仅支持gif,jpg,png格式的图片！');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!' + isLt2M);
                }
                return isJPG && isLt2M;
            },
            // 删除当前图片前的确认
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            // 删除当前图片
            async handleRemove(file, fileList) {
                const { data: res } = await this.$http.post('/admin/scenics/updateImages', {
                    id: file.id
                });
            },
            handlePictureCardPreview(file) {
                this.picture_ImageUrl = file.url;
                this.picture_Visible = true;
            },

            //限制上传文件的数量
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 6 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            // 打开网址对应的图片
            openImg(url) {
                window.open(url, '_blank');
            }
        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }
    .wd600 {
        width: 100%;
    }

    .wd200 {
        width: 200px;
    }
    .wd100 {
        width: 100px;
    }

    .table-td-thumb {
        font-size: 14px;
        padding: 10px;
    }
</style>
